import type { LineChartDataPoint } from '@shared/components/charts/LineChart';
import type { BarChartDataPoint } from '@shared/components/charts/BarChart';

/** Daily transaction volume over the last 14 days */
export const TERMINAL_TRANSACTION_VOLUME_DATA: LineChartDataPoint[] = [
  { name: 'Feb 8', transactions: 142, successful: 138 },
  { name: 'Feb 9', transactions: 158, successful: 154 },
  { name: 'Feb 10', transactions: 123, successful: 119 },
  { name: 'Feb 11', transactions: 187, successful: 182 },
  { name: 'Feb 12', transactions: 201, successful: 195 },
  { name: 'Feb 13', transactions: 176, successful: 171 },
  { name: 'Feb 14', transactions: 234, successful: 228 },
  { name: 'Feb 15', transactions: 248, successful: 241 },
  { name: 'Feb 16', transactions: 192, successful: 187 },
  { name: 'Feb 17', transactions: 215, successful: 209 },
  { name: 'Feb 18', transactions: 267, successful: 261 },
  { name: 'Feb 19', transactions: 243, successful: 237 },
  { name: 'Feb 20', transactions: 228, successful: 222 },
  { name: 'Feb 21', transactions: 289, successful: 283 },
];

/** Connectivity uptime percentage over the last 14 days */
export const TERMINAL_CONNECTIVITY_UPTIME_DATA: LineChartDataPoint[] = [
  { name: 'Feb 8', uptime: 99.9 },
  { name: 'Feb 9', uptime: 100.0 },
  { name: 'Feb 10', uptime: 99.7 },
  { name: 'Feb 11', uptime: 100.0 },
  { name: 'Feb 12', uptime: 99.8 },
  { name: 'Feb 13', uptime: 98.2 },
  { name: 'Feb 14', uptime: 99.9 },
  { name: 'Feb 15', uptime: 100.0 },
  { name: 'Feb 16', uptime: 100.0 },
  { name: 'Feb 17', uptime: 99.6 },
  { name: 'Feb 18', uptime: 100.0 },
  { name: 'Feb 19', uptime: 99.8 },
  { name: 'Feb 20', uptime: 100.0 },
  { name: 'Feb 21', uptime: 99.9 },
];

/** Weekly revenue for the last 8 weeks */
export const TERMINAL_REVENUE_DATA: BarChartDataPoint[] = [
  { name: 'W1', revenue: 324000 },
  { name: 'W2', revenue: 415000 },
  { name: 'W3', revenue: 289000 },
  { name: 'W4', revenue: 542000 },
  { name: 'W5', revenue: 468000 },
  { name: 'W6', revenue: 610000 },
  { name: 'W7', revenue: 537000 },
  { name: 'W8', revenue: 721000 },
];

/** Payment method distribution at terminal */
export const TERMINAL_PAYMENT_METHOD_DATA: BarChartDataPoint[] = [
  { name: 'Chip & PIN', count: 1542 },
  { name: 'Contactless', count: 936 },
  { name: 'Mobile Wallet', count: 412 },
  { name: 'Swipe', count: 198 },
  { name: 'Manual Entry', count: 105 },
  { name: 'QR Code', count: 54 },
];
